export default __webpack_public_path__ + "static/media/MaterialPlastic_04.311fa9af.png";